// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-2947bc3b] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}

/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
li.action[data-v-2947bc3b]:hover, li.action.active[data-v-2947bc3b] {
  border-radius: 6px;
  padding: 0;
}
li.action[data-v-2947bc3b]:hover {
  background-color: var(--color-background-hover);
}
.action--disabled[data-v-2947bc3b] {
  pointer-events: none;
  opacity: 0.5;
}
.action--disabled[data-v-2947bc3b]:hover, .action--disabled[data-v-2947bc3b]:focus {
  cursor: default;
  opacity: 0.5;
}
.action--disabled[data-v-2947bc3b] * {
  opacity: 1 !important;
}
.action-checkbox[data-v-2947bc3b] {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2);
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
  color: var(--color-main-text);
  border: 0;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
  font-weight: normal;
  font-size: var(--default-font-size);
  line-height: var(--default-clickable-area);
}
.action-checkbox > span[data-v-2947bc3b] {
  cursor: pointer;
  white-space: nowrap;
}
.action-checkbox__icon[data-v-2947bc3b] {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  opacity: 1;
  background-position: calc((var(--default-clickable-area) - 16px) / 2) center;
  background-size: 16px;
  background-repeat: no-repeat;
}
.action-checkbox[data-v-2947bc3b] .material-design-icon {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  opacity: 1;
}
.action-checkbox[data-v-2947bc3b] .material-design-icon .material-design-icon__svg {
  vertical-align: middle;
}
.action-checkbox__longtext-wrapper[data-v-2947bc3b], .action-checkbox__longtext[data-v-2947bc3b] {
  max-width: 220px;
  line-height: 1.6em;
  padding: calc((var(--default-clickable-area) - 1.6em) / 2) 0;
  cursor: pointer;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
}
.action-checkbox__longtext[data-v-2947bc3b] {
  cursor: pointer;
  white-space: pre-wrap !important;
}
.action-checkbox__name[data-v-2947bc3b] {
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  display: block;
}
.action-checkbox__description[data-v-2947bc3b] {
  display: block;
  white-space: pre-wrap;
  font-size: var(--font-size-small);
  line-height: var(--default-line-height);
  color: var(--color-text-maxcontrast);
  cursor: pointer;
}
.action-checkbox__menu-icon[data-v-2947bc3b] {
  margin-inline: auto calc((var(--default-clickable-area) - 16px) / 2 * -1);
}
.action[data-v-2947bc3b]:has(:focus-visible) {
  outline: 2px solid currentColor;
}
.action-checkbox__icon[data-v-2947bc3b] {
  color: var(--color-primary-element);
}
.action-checkbox__input[data-v-2947bc3b] {
  width: 20px;
  height: 20px;
  margin: auto;
  position: absolute;
  z-index: -1;
  opacity: 0 !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcActionCheckbox-DLJQfCUI.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,+CAA+C;AACjD;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,oEAAoE;EACpE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,UAAU;EACV,4EAA4E;EAC5E,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4DAA4D;EAC5D,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-2947bc3b] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\nli.action[data-v-2947bc3b]:hover, li.action.active[data-v-2947bc3b] {\n  border-radius: 6px;\n  padding: 0;\n}\nli.action[data-v-2947bc3b]:hover {\n  background-color: var(--color-background-hover);\n}\n.action--disabled[data-v-2947bc3b] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.action--disabled[data-v-2947bc3b]:hover, .action--disabled[data-v-2947bc3b]:focus {\n  cursor: default;\n  opacity: 0.5;\n}\n.action--disabled[data-v-2947bc3b] * {\n  opacity: 1 !important;\n}\n.action-checkbox[data-v-2947bc3b] {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2);\n  box-sizing: border-box;\n  cursor: pointer;\n  white-space: nowrap;\n  color: var(--color-main-text);\n  border: 0;\n  border-radius: 0;\n  background-color: transparent;\n  box-shadow: none;\n  font-weight: normal;\n  font-size: var(--default-font-size);\n  line-height: var(--default-clickable-area);\n}\n.action-checkbox > span[data-v-2947bc3b] {\n  cursor: pointer;\n  white-space: nowrap;\n}\n.action-checkbox__icon[data-v-2947bc3b] {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  opacity: 1;\n  background-position: calc((var(--default-clickable-area) - 16px) / 2) center;\n  background-size: 16px;\n  background-repeat: no-repeat;\n}\n.action-checkbox[data-v-2947bc3b] .material-design-icon {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  opacity: 1;\n}\n.action-checkbox[data-v-2947bc3b] .material-design-icon .material-design-icon__svg {\n  vertical-align: middle;\n}\n.action-checkbox__longtext-wrapper[data-v-2947bc3b], .action-checkbox__longtext[data-v-2947bc3b] {\n  max-width: 220px;\n  line-height: 1.6em;\n  padding: calc((var(--default-clickable-area) - 1.6em) / 2) 0;\n  cursor: pointer;\n  text-align: start;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.action-checkbox__longtext[data-v-2947bc3b] {\n  cursor: pointer;\n  white-space: pre-wrap !important;\n}\n.action-checkbox__name[data-v-2947bc3b] {\n  font-weight: bold;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 100%;\n  display: block;\n}\n.action-checkbox__description[data-v-2947bc3b] {\n  display: block;\n  white-space: pre-wrap;\n  font-size: var(--font-size-small);\n  line-height: var(--default-line-height);\n  color: var(--color-text-maxcontrast);\n  cursor: pointer;\n}\n.action-checkbox__menu-icon[data-v-2947bc3b] {\n  margin-inline: auto calc((var(--default-clickable-area) - 16px) / 2 * -1);\n}\n.action[data-v-2947bc3b]:has(:focus-visible) {\n  outline: 2px solid currentColor;\n}\n.action-checkbox__icon[data-v-2947bc3b] {\n  color: var(--color-primary-element);\n}\n.action-checkbox__input[data-v-2947bc3b] {\n  width: 20px;\n  height: 20px;\n  margin: auto;\n  position: absolute;\n  z-index: -1;\n  opacity: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
